import Handler from "../Handler";

class TourneyInTheBubbleHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    //Here we can reuse same tourney in the money data processing method.
    this.service.processTourneyInTheMoneyData(receivedData);
  }
}
export default TourneyInTheBubbleHandler;

//inthebubble#{"tourneyId":""}
